import ModifyPolicyPage from './lib/Pages/ModifyPolicyPage';
import PoliciesPage from './lib/Pages/PoliciesPage';
export * from './lib/index';

export { PoliciesPage, ModifyPolicyPage };
